/**
 * The one way to check a dog out from a list (#251 should-fix 5).
 *
 * Check-out is a MONEY action: package redemption and the balance prompts, the
 * invoice record, settle now or later, the household checkout, the quiet
 * credit step. The Bookings page owns all of it, and a one-tap POST from a list
 * once let a visit leave the money funnel silently. So every surface that offers
 * check-out sends the desk to that visit's Bookings row, and none of them posts:
 * the dashboard's Departures, the Front Desk's Going home board, and the Going
 * home today list.
 */
export function checkOutPath(bookingId: string): string {
  return `/bookings?focus=${encodeURIComponent(bookingId)}`;
}
